<div class="modal-container">
    <div class="container" id="pdf-content">
        <div id="common-report">
            <div class="page">
                <!-- Logos Section -->
                <div class="header-logos pdf-section">
                    <img [src]="brandingLogo ? brandingLogo : '/assets/caffer-logo-full.svg'" alt="Caffer Logo"
                        loading="lazy" />
                </div>
                <!-- Service Summary -->
                <div class="header-title pdf-section">
                    <span>{{ (isEconomicReport ? 'report_economic' : 'report_service') | translate }}</span>
                    <span>#{{ orderHash }}</span>
                </div>

                <!-- Vehicle Info -->
                <div class="section-content vehicle-info pdf-section">
                    <div class="section-title">{{ 'reports.vehicle_information' | translate }}</div>
                    <div class="vehicle-icon-container">
                        <div class="vehicle-icon">
                            <img [src]="getVehicleIcon(details.VehicleInformation?.ChassisType)" alt="Icono del coche"
                                loading="lazy" />
                        </div>
                        <div class="vehicle-details">
                            <p class="vehicle-title">{{ details.VehicleInformation?.Model }} {{
                                details.VehicleInformation?.LicensePlate }}</p>
                            <p class="vehicle-description">{{ details.VehicleInformation?.Brand }} | {{
                                getFuelType(details.VehicleInformation?.FuelType) }} | {{
                                getChassisType(details.VehicleInformation?.ChassisType) }}</p>
                        </div>
                    </div>
                </div>

                <!-- Pickup and Delivery Address -->
                <div class="section-content service-info pdf-section">
                    <div class="section-title">{{ 'reports.pickup_dropoff' | translate }}</div>
                    <div class="section-details">
                        <p><strong> {{ 'reports.pickup' | translate }}</strong></p>
                        <p>{{ details.OriginAddress }}</p>
                        <p>{{ details.StartDate }}</p>
                    </div>
                    <div class="section-details">
                        <p><strong> {{ 'reports.dropoff' | translate }}</strong></p>
                        <p>{{ details.DestinationAddress ? details.DestinationAddress : details.OriginAddress }}</p>
                        <p>{{ details.EndDate }}</p>
                    </div>
                </div>

                <!-- Services -->
                <div class="section-content pdf-section">
                    <div class="section-title">{{ 'reports.services' | translate }}</div>
                    <div class="service-title" *ngFor="let item of details.FinancialInformation?.Products">
                        <app-service-icons [isActiveRouteMap]="true" [ServiceProductKey]="item.ProductKey!"
                            [newServiceIcons]="true"></app-service-icons>
                        <p class="service_type_detail_text">{{ 'PRODUCT_KEY_NAME.' + item.ProductKey! | translate }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div id="economic-report" *ngIf="isEconomicReport">
            <div class="page">
                <div class="section-content pdf-section">
                    <div class="section-title">{{ 'reports.costs' | translate }}</div>
                    <div class="cost-container">
                        <div class="cost-item" *ngFor="let item of details.FinancialInformation?.Products">
                            <div class="service-info-2">
                                <app-service-icons [isActiveRouteMap]="true" [ServiceProductKey]="item.ProductKey!"
                                    [newServiceIcons]="true"></app-service-icons>
                                <p class="service_type_detail_text">{{ 'PRODUCT_KEY_NAME.' + item.ProductKey! |
                                    translate }}</p>
                            </div>
                            <p class="price">{{ item.Amount }}{{ details.StartZoneId | CurrencyByZoneId }}</p>
                        </div>

                        <div class="cost-item" *ngFor="let item of details.FinancialInformation?.Fees; index as i">
                            <div class="service-info-2">
                                <p>{{ item.ProductKey | translate }}</p>
                            </div>
                            <p class="price">{{ item.Amount }}{{ details.StartZoneId | CurrencyByZoneId }}</p>
                        </div>

                        <div class="cost-item">
                            <p>I.V.A ({{ details.FinancialInformation?.TaxPercentage }}%)</p>
                            <p class="price">{{ details.FinancialInformation?.TotalOrderTaxAmount }}{{
                                details.StartZoneId | CurrencyByZoneId }}</p>
                        </div>

                        <div class="cost-item" *ngFor="let expense of details.FinancialInformation?.Expenses">
                            <div class="service-info-2">
                                <p>{{ expenseLabel(expense) }}</p>
                            </div>
                            <p class="price">{{ expense.Amount }}{{ details.StartZoneId | CurrencyByZoneId }}</p>
                        </div>

                        <div class="total-separator"></div>
                        <div class="cost-item total">
                            <p>{{ 'total' | translate }}</p>
                            <p class="price">{{ details.FinancialInformation?.TotalOrderAmount }}{{
                                details.StartZoneId | CurrencyByZoneId }}</p>
                        </div>
                    </div>
                </div>

                <div class="section-content documentation pdf-section" *ngIf="expenseReceipts.length">
                    <div class="section-title">{{ 'reports.expense_receipts' | translate }}</div>
                    <div class="documentation-container">
                        <div class="documentation-image" *ngFor="let receipt of expenseReceipts">
                            <a [href]="receipt" target="_blank"><img [src]="receipt" alt="expense receipt"
                                    loading="lazy" crossorigin="anonymous" /></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="service-report" *ngIf="!isEconomicReport">
            <div class="page">
                <div class="section-content documentation pdf-section"
                    *ngIf="details.TrackingInformation?.Documentation">
                    <div class="section-title">{{ 'reports.documentation' | translate }}</div>
                    <div class="documentation-container"
                        *ngIf="details.TrackingInformation?.Documentation?.ImagesUrls?.length">
                        <div class="documentation-image"
                            *ngFor="let image of details.TrackingInformation?.Documentation?.ImagesUrls">
                            <a [href]="image" target="_blank"><img [src]="image" alt="documentation" loading="lazy"
                                    crossorigin="anonymous" /></a>
                        </div>
                    </div>
                    <div class="opcional" *ngIf="!details.TrackingInformation?.Documentation?.ImagesUrls?.length">
                        <p>{{ 'reports.no_documentation' | translate }}</p>
                    </div>
                </div>
            </div>

            <div class="page">
                <div class="header-title-2 pdf-section pdf-break">{{ 'reports.vehicle_pickup' | translate }}</div>
                <div class="section-content documentation pdf-section"
                    *ngIf="details.TrackingInformation?.PickupClientSignature">
                    <div class="section-title">{{ 'reports.client_information' | translate }}</div>
                    <p>{{ 'reports.name' | translate }} {{
                        details.TrackingInformation?.PickupClientSignature?.ClientName }}</p>
                    <p>{{ 'reports.dni' | translate }} {{
                        details.TrackingInformation?.PickupClientSignature?.ClientDocumentId }}</p>
                    <p><strong>{{ 'reports.client_signature' | translate }}</strong></p>
                    <div class="photography">
                        <a [href]="details.TrackingInformation?.PickupClientSignature?.ImageUrl" target="_blank">
                            <img [src]="details.TrackingInformation?.PickupClientSignature?.ImageUrl"
                                alt="Firma recogida" loading="lazy" crossorigin="anonymous" />
                        </a>
                    </div>
                </div>

                <div class="pdf-section mileage-fuel">
                    <div class="section-content documentation half-section"
                        *ngIf="details.TrackingInformation?.PickupMileage">
                        <div class="section-title">{{ 'reports.odometer' | translate }}</div>
                        <p>{{ 'reports.odometer_value' | translate }} {{
                            details.TrackingInformation?.PickupMileage?.Mileage }}</p>
                        <div class="photography">
                            <a [href]="details.TrackingInformation?.PickupMileage?.ImageUrl" target="_blank"><img
                                    [src]="details.TrackingInformation?.PickupMileage?.ImageUrl" alt="Cuentakilómetros"
                                    loading="lazy" crossorigin="anonymous" /></a>
                        </div>
                    </div>

                    <div class="section-content documentation half-section"
                        *ngIf="details.TrackingInformation?.PickupFuel">
                        <div class="section-title">{{ 'reports.fuel_level' | translate }}</div>
                        <p>{{ 'reports.fuel_level_value' | translate }} {{
                            details.TrackingInformation?.PickupFuel?.FuelLevel }}/4</p>
                        <div class="photography">
                            <img [src]="'../../../../../assets/images/fuel-' + details.TrackingInformation?.PickupFuel?.FuelLevel + '.png'"
                                alt="Nivel de combustible" loading="lazy" crossorigin="anonymous" />
                        </div>
                    </div>
                </div>
            </div>

            <div id="pickup_Images" *ngIf="!showPDF">
                <div class="page">
                    <div class="section-content documentation pdf-section">
                        <div class="section-title">{{ 'reports.vehicle_images' | translate }}</div>
                        <div class="photos">
                            <a *ngFor="let image of details.TrackingInformation?.PickupImages" [href]="image"
                                target="_blank"><img [src]="image" alt="Foto recogida" loading="lazy"
                                    crossorigin="anonymous" /></a>
                        </div>
                    </div>
                </div>
            </div>

            <div id="pickup_Images_pdf" *ngIf="showPDF">
                <ng-container *ngFor="let imagePage of paginatedPickupImages; let i = index">
                    <div class="page">
                        <div class="section-content documentation pdf-section">
                            <div class="section-title" *ngIf="i == 0">{{ 'reports.vehicle_images' | translate }}
                            </div>
                            <div class="photos">
                                <a *ngFor="let image of imagePage" [href]="image" target="_blank"><img [src]="image"
                                        alt="Foto recogida" loading="lazy" crossorigin="anonymous" /></a>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

            <div class="page">
                <div class="header-title-2 pdf-section pdf-break">{{ 'reports.vehicle_dropoff' | translate }}</div>

                <div class="section-content documentation pdf-section"
                    *ngIf="details.TrackingInformation?.DropoffClientSignature">
                    <div class="section-title">{{ 'reports.client_information' | translate }}</div>
                    <p>{{ 'reports.name' | translate }} {{
                        details.TrackingInformation?.DropoffClientSignature?.ClientName }}</p>
                    <p>{{ 'reports.dni' | translate }} {{
                        details.TrackingInformation?.DropoffClientSignature?.ClientDocumentId }}</p>
                    <p><strong>{{ 'reports.client_signature' | translate }}</strong></p>
                    <div class="photography">
                        <a [href]="details.TrackingInformation?.DropoffClientSignature?.ImageUrl" target="_blank"><img
                                [src]="details.TrackingInformation?.DropoffClientSignature?.ImageUrl"
                                alt="Firma entrega" loading="lazy" crossorigin="anonymous" /></a>
                    </div>
                </div>

                <div class="pdf-section mileage-fuel">
                    <div class="section-content documentation half-section"
                        *ngIf="details.TrackingInformation?.DropoffMileage">
                        <div class="section-title">{{ 'reports.odometer' | translate }}</div>
                        <p>{{ 'reports.odometer_value' | translate }} {{
                            details.TrackingInformation?.DropoffMileage?.Mileage }}</p>
                        <div class="photography">
                            <a [href]="details.TrackingInformation?.DropoffMileage?.ImageUrl" target="_blank"><img
                                    [src]="details.TrackingInformation?.DropoffMileage?.ImageUrl" alt="Cuentakilómetros"
                                    loading="lazy" crossorigin="anonymous" /></a>
                        </div>
                    </div>

                    <div class="section-content documentation half-section"
                        *ngIf="details.TrackingInformation?.DropoffFuel">
                        <div class="section-title">{{ 'reports.fuel_level' | translate }}</div>
                        <p>{{ 'reports.fuel_level_value' | translate }} {{
                            details.TrackingInformation?.DropoffFuel?.FuelLevel }}/4</p>
                        <div class="photography">
                            <img [src]="'../../../../../assets/images/fuel-' + details.TrackingInformation?.DropoffFuel?.FuelLevel + '.png'"
                                alt="Nivel de combustible" loading="lazy" crossorigin="anonymous" />
                        </div>
                    </div>
                </div>
            </div>

            <div id="dropoff_Images" *ngIf="!showPDF">
                <div class="page">
                    <div class="section-content documentation pdf-section"
                        *ngIf="details.TrackingInformation?.DropoffImages">
                        <div class="section-title">{{ 'reports.vehicle_images' | translate }}</div>
                        <div class="photos">
                            <a *ngFor="let image of details.TrackingInformation?.DropoffImages" [href]="image"
                                target="_blank"><img [src]="image" alt="Foto 1 entrega" loading="lazy"
                                    crossorigin="anonymous" /></a>
                        </div>
                    </div>
                </div>
            </div>

            <div id="dropoff_Images_pdf" *ngIf="showPDF">
                <ng-container *ngFor="let imagePage of paginatedDropoffImages; let i = index">
                    <div class="page">
                        <div class="section-content documentation pdf-section">
                            <div class="section-title" *ngIf="i == 0">{{ 'reports.vehicle_images' | translate }}
                            </div>
                            <div class="photos">
                                <a *ngFor="let image of imagePage" [href]="image" target="_blank"><img [src]="image"
                                        alt="Foto recogida" loading="lazy" crossorigin="anonymous" /></a>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

            <div class="terms">
                {{ 'reports.signature-1' | translate }} <a href="https://cafler.com/es/terminos-y-condiciones/">{{
                    'reports.signature-2' | translate }}</a>.
            </div>
        </div>
    </div>
</div>